import Vue from 'vue'

const handleFocus = ({ el, input, back = false, isInside = false }) => {
  const FOCUS_SUBJECTS =
    'input.el-input__inner:not([disabled]):not([readonly]), textarea.el-textarea__inner:not([disabled]):not([readonly]), input[type="password"]'

  let inputElements = []

  if (isInside) {
    const form = el.closest('.el-form')

    if (!form) return

    inputElements = Array.from(form.querySelectorAll(FOCUS_SUBJECTS))
  } else {
    inputElements = Array.from(document.querySelectorAll(FOCUS_SUBJECTS))
  }

  const currentIndex = inputElements.indexOf(input)
  const move = back ? -1 : 1
  let nextMoveIndex = currentIndex + move

  if (nextMoveIndex > -1 && nextMoveIndex < inputElements.length) {
    while (isHidden(inputElements[nextMoveIndex]) && nextMoveIndex < inputElements.length) {
      nextMoveIndex++
    }

    inputElements[nextMoveIndex]?.focus()
  }
}

const isHidden = (el) => {
  return el?.offsetParent === null || el?.offsetParent === undefined
}

Vue.directive('focusNextOnEnter', {
  inserted: (el, binding) => {
    const input = el.querySelector('input.el-input__inner')

    let isComposing = false

    input.addEventListener('compositionstart', () => {
      isComposing = true
    })

    input.addEventListener('compositionend', (event) => {
      isComposing = false
      const { value } = event.target
      const sanitizedValue = sanitizeInput(value)
      event.target.value = sanitizedValue
      if (sanitizedValue.length >= input.maxLength) {
        handleFocus({ el, input })
      }
    })

    function sanitizeInput(input) {
      return binding.value?.pattern ? input.replace(binding.value.pattern, '') : input // Remove non-numeric characters
    }

    input.addEventListener('input', (ev) => {
      // End with special characters are not allowed
      if (/[!-/:-@[-`{-~]/.test(ev.data)) return

      const { value } = input

      if (binding.value?.matchPattern && !binding.value.matchPattern.test(value)) return

      if (!isComposing && value.length >= input.maxLength) {
        handleFocus({ el, input })
      }
    })
  },
})
